export default __webpack_public_path__ + "static/envelope-build-action-form-fba33bbd98c5a1684ccf26666e45e0d7.png";